import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRCodeComponent } from './qr-code-component'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [QRCodeComponent],
  exports: [QRCodeComponent]
})
export class QrCodeModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/qr-code/qr-code.module.ts